var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { strokeWidth } from "apparatus/draw";
import { P, Pivot, R, Segments } from "apparatus/library/common";
import { Group, Path, Symbol } from "paper";
import { Random } from "random/random";
import { staticImplements } from "types";
let IceBath = class IceBath {
    constructor() {
        this.drivers = [
            {
                type: "rectangle",
                minX: 37.5, maxX: 250,
                minY: 100, maxY: 300,
                fromAppearance: a => P(a.width / 2, a.height),
                toAppearance: (f, p) => f({ width: p.x * 2, height: p.y }),
                scale: P(1.0, 2.0),
            }
        ];
    }
    render(appearance) {
        const { width, height, size } = appearance;
        const spacing = size * appearance.spacing;
        const maxLayers = Math.floor(height / spacing + 0.5);
        const layers = Math.min(maxLayers, appearance.layers);
        let r = new Random();
        const container = new Path(Segments([[-width / 2, 0]], [[-width / 2, height]], [[width / 2, height]], [[width / 2, 0]])).withStroke("default");
        const iceGroup = new Group([]);
        const mask = new Path.Rectangle(R(0, height, width, height + spacing, Pivot.BOTTOM_CENTER));
        iceGroup.addChild(mask);
        iceGroup.clipped = true;
        const iceGraphic = new Path.Rectangle(R(0, 0, size, size, Pivot.CENTER), 4.0).withDefaultStyle()
            .withStroke("thin", "#bbf0f2")
            .setRadialGradientFill([["#f2ffffee", 0.2], ["#e6fcfcaa", 1]]);
        const ice = new Symbol(iceGraphic, true);
        let boundx = width / 2 - size / 2 - spacing * 0.1;
        for (let i = 0; i < layers; i++) {
            let iterBound;
            if (i % 2 == 0) {
                iterBound = Math.floor(boundx / spacing);
            }
            else {
                iterBound = Math.floor((boundx / spacing) - 0.5) + 0.5;
            }
            for (let j = -iterBound; j <= iterBound; j++) {
                const point = P((j * spacing), height - size * 0.6 - i * spacing)
                    .add(r.randomUniformVector(spacing * 0.17));
                const newIce = ice.place(point);
                newIce.rotate(r.randomBetween(-30, 30));
                iceGroup.addChild(newIce);
            }
        }
        const graphic = new Group([iceGroup, container]);
        const strokeWidthAdjustment = P(0, -strokeWidth("default") / 2);
        return {
            graphic,
            hitShape: graphic.rectHitShape(),
            pivot: container.bounds.center,
            snapping: [
                graphic.placeable(),
                {
                    type: "placeable_surface",
                    start: container.bounds.bottomLeft.add(strokeWidthAdjustment),
                    end: container.bounds.bottomRight.add(strokeWidthAdjustment)
                }
            ]
        };
    }
};
IceBath.properties = {
    label: "Ice Bath",
    defaultAppearance: {
        width: 300,
        height: 160,
        spacing: 1.18,
        layers: 4,
        size: 20,
        randomization: 0.18
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "width", label: "Width",
            min: 75, max: 500
        },
        {
            spec: "slider", key: "height", label: "Height",
            min: 100, max: 300
        },
        { spec: "header", header: "Ice", icon: "dice-d6" },
        {
            spec: "slider", key: "layers", label: "Layers",
            min: 1, max: 8,
        },
        {
            spec: "slider", key: "size", label: "Size",
            min: 15, max: 30, unit: "mm"
        },
        {
            spec: "slider", key: "spacing", label: "Spacing",
            min: 0.9, max: 1.5, step: 0.01
        },
    ],
};
IceBath = __decorate([
    staticImplements()
], IceBath);
export { IceBath };
